import { ActionBlock } from "./ActionBlock";
import { ChartBlock } from "./ChartBlock";
import { CitationBlock } from "./CitationBlock";
import type { ChatBlock } from "./chat-block.types";
import { MetricBlock } from "./MetricBlock";
import { TableBlock } from "./TableBlock";
import { TextBlock } from "./TextBlock";
import { UnsupportedBlock } from "./UnsupportedBlock";

type Props = {
	block: ChatBlock;
	isUser: boolean;
};

// Maps a typed block to its renderer. Phase 2 implements text/metric/table/chart/
// citation; diagram/action/workflow still fall through to UnsupportedBlock until
// phases 3-4. The default case keeps this total, so it never throws on a new type.
export function BlockRenderer({ block, isUser }: Props) {
	switch (block.type) {
		case "text":
			return <TextBlock block={block} isUser={isUser} />;
		case "metric":
			return <MetricBlock block={block} />;
		case "table":
			return <TableBlock block={block} />;
		case "chart":
			return <ChartBlock block={block} />;
		case "citation":
			return <CitationBlock block={block} />;
		case "action":
			return <ActionBlock block={block} />;
		default:
			return <UnsupportedBlock block={block} />;
	}
}
